import { render, staticRenderFns } from "./BatchResult.vue?vue&type=template&id=6231a192&scoped=true&"
import script from "./BatchResult.vue?vue&type=script&lang=js&"
export * from "./BatchResult.vue?vue&type=script&lang=js&"
import style0 from "./BatchResult.vue?vue&type=style&index=0&id=6231a192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6231a192",
  null
  
)

export default component.exports